import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Grid } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router';
import { FormProvider, RHFAutocomplete, RHFTextField } from 'src/components';
import { Paths } from 'src/config';
import { CATEGORY_STATUS } from 'src/helpers/Category';
import { useEditCategoryMutation, useGetCategorysQuery } from 'src/redux/services/CategoryServices';
import * as Yup from 'yup';

const CategoryEditValidationSchema = Yup.object({
  name: Yup.string().required('نام اجباری می باشد'),
  slug: Yup.string().required('اسلاگ اجباری می باشد'),
  parent: Yup.object({
    name: Yup.string(),
    _id: Yup.string(),
  }),
  status: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  }),
}).required();

export const CategoryEditForm = () => {
  const { state } = useLocation();
  const [isCategoryListOpen, setIsCategoryListOpen] = useState(false);
  const navigate = useNavigate();
  const [editCategory, { isLoading }] = useEditCategoryMutation();
  const { data, isFetching } = useGetCategorysQuery({}, { skip: !isCategoryListOpen });
  const methods = useForm({
    defaultValues: {
      name: state?.name,
      slug: state?.slug,
      parent: { name: state?.parent?.name || '', _id: state?.parent?._id || '' },
      status: CATEGORY_STATUS[state?.status],
    },
    resolver: yupResolver(CategoryEditValidationSchema),
  });
  const { handleSubmit } = methods;
  const CategoryStatusOptions = Object.values(CATEGORY_STATUS);

  function handleOpenCategoryListOpen() {
    setIsCategoryListOpen(true);
  }
  function handleCloseCategoryListOpen() {
    setIsCategoryListOpen(false);
  }
  async function onSubmit(values) {
    try {
      const body = {
        _id: state?._id,
        name: values.name,
        slug: values.slug,
        parent: !!values?.parent?._id || values?.parent?._id !== '' ? values?.parent?._id : undefined,
        status: values?.status?.value,
      };
      await editCategory(body).unwrap();
      enqueueSnackbar(`دسته بندی ${values.name} ویرایش شد`, { variant: 'success' });
      navigate(Paths.category.list.path);
    } catch (error) {
      console.log('CREATE CATEGORY ERROR', error);
      if (error?.data?.err === `category with name ${values.name} already exists!`) {
        enqueueSnackbar(`دسته بندی با نام ${values.name} قبلا ایجاد شده است`, { variant: 'warning' });
      } else if (error?.data?.err === `category with slug ${values.slug} already exists!`) {
        enqueueSnackbar(`دسته بندی با اسلاگ ${values.slug} قبلا ایجاد شده است`, { variant: 'warning' });
      } else {
        enqueueSnackbar(`دسته بندی ${values.name} ویرایش نشد`, { variant: 'error' });
      }
    }
  }

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <RHFTextField name={'name'} label={'نام'} />
        </Grid>
        <Grid item xs={6}>
          <RHFTextField name={'slug'} label={'اسلاگ'} />
        </Grid>
        <Grid item xs={6}>
          <RHFAutocomplete
            name={'parent'}
            label={'والد'}
            defaultValue={''}
            options={data?.categories || []}
            disableClearable
            getOptionLabel={(option) => option?.name}
            getOptionDisabled={(option) => option?._id === state?._id}
            onChange={(event, newValue) => {
              methods.setValue('parent', { name: newValue.name, _id: newValue._id });
              methods.clearErrors('parent', '');
            }}
            loading={isFetching}
            open={isCategoryListOpen}
            onOpen={handleOpenCategoryListOpen}
            onClose={handleCloseCategoryListOpen}
          />
        </Grid>
        <Grid item xs={6}>
          <RHFAutocomplete
            name={'status'}
            label={'وضعیت'}
            options={CategoryStatusOptions || []}
            disableClearable
            getOptionLabel={(option) => option?.label}
            onChange={(event, newValue) => {
              methods.setValue('status', newValue);
              methods.clearErrors('status', '');
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" disabled={isLoading} type="submit">
            {Paths.category.edit.title}
          </Button>
        </Grid>
      </Grid>
    </FormProvider>
  );
};
